/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The JobProofLink model module.
 * @module model/JobProofLink
 * @version V1
 */
class JobProofLink {
    /**
     * Constructs a new <code>JobProofLink</code>.
     * @alias module:model/JobProofLink
     */
    constructor() { 
        
        JobProofLink.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>JobProofLink</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/JobProofLink} obj Optional instance to populate.
     * @return {module:model/JobProofLink} The populated <code>JobProofLink</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new JobProofLink();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('accountId')) {
                obj['accountId'] = ApiClient.convertToType(data['accountId'], 'Number');
            }
            if (data.hasOwnProperty('jobId')) {
                obj['jobId'] = ApiClient.convertToType(data['jobId'], 'Number');
            }
            if (data.hasOwnProperty('proofId')) {
                obj['proofId'] = ApiClient.convertToType(data['proofId'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('createdBy')) {
                obj['createdBy'] = ApiClient.convertToType(data['createdBy'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>JobProofLink</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>JobProofLink</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} id
 */
JobProofLink.prototype['id'] = undefined;

/**
 * @member {Number} accountId
 */
JobProofLink.prototype['accountId'] = undefined;

/**
 * @member {Number} jobId
 */
JobProofLink.prototype['jobId'] = undefined;

/**
 * @member {Number} proofId
 */
JobProofLink.prototype['proofId'] = undefined;

/**
 * @member {Date} createdAt
 */
JobProofLink.prototype['createdAt'] = undefined;

/**
 * @member {Number} createdBy
 */
JobProofLink.prototype['createdBy'] = undefined;






export default JobProofLink;

